import React, { useState, useCallback, useEffect } from "react";

import "./SecondaryMenu.scss";
import Svg from "../svg/Svg";
import { Toggle as ToggleIcon } from "../svg/svgImageList";
import MenuSection from "./MenuSection";
import { MenuItemProps as MenuItem } from "./MenuItem";
import useThemeService from "../../services/theme-service/ThemeService";

export interface SecondaryMenuItems {
  staticItems?: MenuItems;
  dynamicItems?: MenuItems;
}

export interface SecondaryMenuType extends SecondaryMenuItems {
  onMenuToggle?: Function;
}

export interface MenuItems {
  [menuSection: string]: {
    sectionName?: string | JSX.Element;
    items: Array<MenuItem>;
    defaultOpen: boolean;
  };
}

export default function SecondaryMenu(props: SecondaryMenuType) {
  const [openMenu, setOpenMenu] = useState(true);

  const { onMenuToggle: onToggleMenu } = { ...props };
  const staticMenuItems: MenuItems = props.staticItems || {};
  const dynamicMenuItems: MenuItems = props.dynamicItems || {};
  const menuItems = Object.assign({}, staticMenuItems, dynamicMenuItems);
  const menuSections = Object.keys(menuItems);
  const menuCategory = window.location.pathname.split("/")[1];

  const { themeClass } = useThemeService();

  const handleOpenMenu = useCallback(() => {
    setOpenMenu((openMenu) => !openMenu);
  }, []);

  useEffect(() => {
    if (onToggleMenu) {
      onToggleMenu(openMenu);
    }
  }, [openMenu, onToggleMenu]);

  if (!menuSections.length) {
    return null;
  }

  return (
    <nav className={themeClass(["nav-secondary-menu"], [openMenu ? "with-scroll" : "no-scroll"])}>
      <header className="secondary-menu-header">
        <Svg
          svg={ToggleIcon}
          className={themeClass(["secondary-menu-toggle"], [!openMenu ? "reverse-toggle" : ""])}
          onClick={() => handleOpenMenu()}
        />
      </header>
      {openMenu && (
        <div>
          {menuSections.map(
            (menuSection) =>
              atLeastOneMenuItemCanBeAccessed(menuSection) && (
                <MenuSection
                  key={menuSection}
                  labelKey={menuItems[menuSection].sectionName || menuSection}
                  items={menuItems[menuSection].items}
                  menuCategory={menuCategory}
                  defaultOpen={menuItems[menuSection].defaultOpen}
                />
              )
          )}
        </div>
      )}
    </nav>
  );

  function atLeastOneMenuItemCanBeAccessed(menuSection: string) {
    return menuItems[menuSection].items.some((x) => x.canAccess);
  }
}
